// components
import type { ITopicListItem } from '@newo/api/gateway';
import WorkflowStep from '@/pages/Workflow/components/WorkflowStep';
// utils
import { buildChain } from '@/pages/Workflow/Workflow.utils.ts';
import useWorkflowStore from '@/pages/Workflow/Workflow.store.ts';
// assets
import styles from '@/pages/Workflow/components/Main/Main.module.css';

interface MainProps {
    items: ITopicListItem[];
}

const Main = ({ items }: MainProps) => {
    const filters = useWorkflowStore((state) => state.filters);
    const tasks = items.filter(({ topic }) =>
        topic.labels.includes(filters.workflow)
    );

    const chains = buildChain(tasks, filters);
    return (
        <div className={styles.wrapper}>
            <div className={styles.main}>
                {chains.map((column, index) => {
                    return (
                        <div className={styles.column} key={index}>
                            {column.map((step, ind) => {
                                return (
                                    <WorkflowStep
                                        data={step}
                                        key={`${step.name}-${ind}`}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Main;
